import { NextUserStatus } from '@/types/userStatus';

export enum ActionTypes {
  FETCH_USER_STATUS_START = 'userStatusNext/FETCH_USER_STATUS_START',
  FETCH_USER_STATUS_UPDATE = 'userStatusNext/FETCH_USER_STATUS_UPDATE',
  FETCH_USER_STATUS_SUCCESS = 'userStatusNext/FETCH_USER_STATUS_SUCCESS',
  FETCH_USER_STATUS_FAIL = 'userStatusNext/FETCH_USER_STATUS_FAIL',
  UPDATE_PROMOTIONS_AVAILABLE = 'userStatusNext/UPDATE_PROMOTIONS_AVAILABLE',
  CLEAN_USER_STATUS = 'userStatusNext/CLEAN_USER_STATUS',
}

export interface State {
  isLoading: boolean;
  mustUpdate: boolean;
  error: string;
  data?: NextUserStatus;
}

export interface FetchUserStatusStartAction {
  type: ActionTypes.FETCH_USER_STATUS_START;
}
export interface FetchUserStatusUpdateAction {
  type: ActionTypes.FETCH_USER_STATUS_UPDATE;
}
export interface FetchUserStatusSuccessAction {
  type: ActionTypes.FETCH_USER_STATUS_SUCCESS;
  payload: NextUserStatus;
}
export interface FetchUserStatusFailAction {
  type: ActionTypes.FETCH_USER_STATUS_FAIL;
  payload: string;
}
export interface UpdatePromotionsAvailableAction {
  type: ActionTypes.UPDATE_PROMOTIONS_AVAILABLE;
  payload: number;
}

export interface cleanUserStatusAction {
  type: ActionTypes.CLEAN_USER_STATUS;
}

export type ActionType =
  | FetchUserStatusStartAction
  | FetchUserStatusUpdateAction
  | FetchUserStatusSuccessAction
  | FetchUserStatusFailAction
  | UpdatePromotionsAvailableAction
  | cleanUserStatusAction;
